import { apiClient } from './client';

export interface ScrapingResponse {
  message: string;
  job_id?: string;
}

export interface SchedulerJob {
  id: string;
  name: string;
  next_run_time: string | null;
}

export interface ScrapingStatusResponse {
  running: boolean;
  jobs: SchedulerJob[];
  running_company_ids: number[];  // 実行中の法人ID
}

// 特定法人のスクレイピング実行
export const runScrapingForCompany = async (companyId: number): Promise<ScrapingResponse> => {
  const response = await apiClient.post<ScrapingResponse>(`/api/scraping/run/${companyId}`);
  return response.data;
};

// 全法人のスクレイピング実行
export const runScrapingAll = async (): Promise<ScrapingResponse> => {
  const response = await apiClient.post<ScrapingResponse>('/api/scraping/run-all');
  return response.data;
};

// スケジューラー状態取得
export const getSchedulerStatus = async (): Promise<ScrapingStatusResponse> => {
  const response = await apiClient.get<ScrapingStatusResponse>('/api/scraping/scheduler/status');
  return response.data;
};

// スケジューラー開始
export const startScheduler = async (): Promise<ScrapingResponse> => {
  const response = await apiClient.post<ScrapingResponse>('/api/scraping/scheduler/start');
  return response.data;
};

// スケジューラー停止
export const stopScheduler = async (): Promise<ScrapingResponse> => {
  const response = await apiClient.post<ScrapingResponse>('/api/scraping/scheduler/stop');
  return response.data;
};
